/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'providers/AuthProvider';
import axiosInstance from 'utils/axiosInterceptors';
import { useNavigate } from 'react-router-dom';
import { useBranchContext, Branch } from 'providers/BranchProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';

const useBranchList = (): Branch[] => {
  const { setBranches, setSelectedBranch } = useBranchContext();
  const { setAvatarInitials } = useMainLayoutContext();

  const auth = useContext(AuthContext) || {
    token: null,
    loading: false,
    error: null,
    dispatch: () => {}
  };
  const { token } = auth;
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const getBranchList = async () => {
    try {
      const { data: currentUser } = await axiosInstance.get(
        '/api/v1/users/currentUserDetail'
      );

      const { data: branchList } = await axiosInstance.get('/api/v1/branches');

      const filteredBranches = branchList.filter((branch: { branchId: any }) =>
        currentUser.branchRoles.some(
          (role: { branchId: any }) => role.branchId === branch.branchId
        )
      );

      setData(filteredBranches);
      setBranches(filteredBranches);
      setSelectedBranch(filteredBranches[0] || null);
      setAvatarInitials(
        currentUser.lastname.charAt(0).toUpperCase() +
          currentUser.firstname.charAt(0).toUpperCase()
      );
    } catch (error) {
      console.error('Failed to fetch branches', error);
    }
  };

  useEffect(() => {
    if (token) {
      getBranchList();
    } else if (token === null) {
      navigate('/sign-in');
    }
  }, [token, navigate]);

  return data;
};

export default useBranchList;
